import React, { useEffect, useMemo, useState } from 'react';
import { SafeAreaView, Pressable, View } from 'react-native';
import {
  doc,
  collection,
  addDoc,
  serverTimestamp,
  onSnapshot,
  deleteDoc,
} from 'firebase/firestore';
import THEME from '../../../config/theme';
import { useNavigation, useRoute } from '@react-navigation/native';

import Header from '../../../components/Header';
import * as S from './styles';
import { useCommunity } from '../ContextCommunity/CommunityContext';
import { ActivityIndicator, Provider } from 'react-native-paper';
import CardCommunity from '../CardCommunity';
import { Feather, FontAwesome } from '@expo/vector-icons';
import TextInput from '../../../components/TextInput';
import CommentItem from '../../../components/VideoComments/CommentItem';
import { FlatList } from 'react-native';
import { useCustomTheme } from '../../../contexts/useCustomTheme';
import { useAuthUser } from '../../../contexts/useAuthUser';

const PostCommunity = ({ routePostId }) => {
  const {
    filterPostForId,
    posts,
    post,
    loadingCard,
    handleCommentSubmit,
    handleReplySubmit,
    isAdminOrIsUserCurrent,
    handleDeleteComment,
    handleDeleteReply,
    handleDeletePost,
    handleLike,
  } = useCommunity();
  const navigation = useNavigation();
  // Documento `users/{uid}` vem do AuthUserProvider (resolvido no boot).
  const { user: authUserDoc, userId } = useAuthUser();
  const isUser = useMemo(
    () => (authUserDoc ? { id: userId, ...authUserDoc } : null),
    [authUserDoc, userId]
  );
  const route = useRoute();

  const [comment, setComment] = useState('');
  const [isReply, setIsReply] = useState(false);
  const [dataReply, setDataReply] = useState(null);

  const { customColor, customFont } = useCustomTheme();

  const effectivePostId = routePostId || route.params?.id;

  useEffect(() => {
    if (!effectivePostId || loadingCard) return;
    filterPostForId(effectivePostId);
  }, [posts, effectivePostId, loadingCard]);

  if (loadingCard) {
    return (
      <ActivityIndicator
        style={{
          flex: 1,
          backgroundColor:
            customColor && customColor.background
              ? customColor.background.auth
              : THEME.COLORS.BACKGROUND_ABOUT,
          justifyContent: 'center',
        }}
        color={
          customColor && customColor.primary
            ? customColor.primary
            : THEME.COLORS.PRIMARY_800
        }
      />
    );
  }

  const submitReply = (dataReply, comment, id) => {
    if (!comment.trim()) return;
    handleReplySubmit(dataReply, comment, id);
    setIsReply(false);
    setComment('');
  };

  const idPost = effectivePostId;
  const isCommentValid = comment.trim().length > 0;

  return (
    <Provider>
      <SafeAreaView
        style={{
          backgroundColor:
            customColor && customColor.background?.app
              ? customColor.background.app
              : THEME.COLORS.BACKGROUND_MAIN,
          minHeight: '100%',
        }}
      >
        <View>
          <Header
            onPress={() => {
              // Aberto pela central de comentários: volta para a lista, e não
              // para o feed. Sem histórico (link aberto direto), segue o normal.
              if (route.params?.fromComments && navigation.canGoBack()) {
                navigation.goBack();
                return;
              }
              navigation.navigate('Community');
            }}
            user={isUser}
          />
        </View>
        <S.CardContainer>
          <CardCommunity
            posts={post}
            handleLike={handleLike}
            user={isUser}
            handleDeletePost={handleDeletePost}
            isRoute={effectivePostId}
          />
        </S.CardContainer>

        {
          <S.ViewComment
            style={{
              backgroundColor:
                customColor && customColor.background?.app
                  ? customColor.background.app
                  : THEME.COLORS.BACKGROUND_MAIN,
            }}
          >
            <FlatList
              data={post[0]?.dataComments || []}
              keyExtractor={(item, index) => item.id || index.toString()}
              renderItem={({ item }) => (
                <CommentItem
                  login={isUser}
                  comment={item}
                  editPlaceholder={() => {}}
                  setIsLoading={() => {}}
                  community={route.name.includes('Community')}
                  handleReplySubmit={handleReplySubmit}
                  handleDeleteComment={handleDeleteComment}
                  handleDeleteReply={handleDeleteReply}
                  changeReply={setIsReply}
                  getDataReply={setDataReply}
                  isAdminOrIsUserCurrent={isAdminOrIsUserCurrent}
                  idPost={idPost}
                />
              )}
            />
          </S.ViewComment>
        }

        {
          <S.CommentContainer
            style={{
              backgroundColor:
                customColor && customColor.background?.app
                  ? customColor.background.app
                  : THEME.COLORS.BACKGROUND_MAIN,
            }}
          >
            <Feather
              name="user"
              size={22}
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.TEXT_MAIN
              }
            />
            <TextInput
              placeholder={
                isReply
                  ? `Responder ${dataReply?.userName}`
                  : 'Faça um comentário'
              }
              value={comment}
              onChangeText={setComment}
              placeholderTextColor="#7F7F7F"
              width={'90%'}
              fontFamily={
                customFont && customFont.fontFamilyText
                  ? customFont.fontFamilyText
                  : THEME.FONTFAMILY.REGULAR
              }
            />

            <Pressable
              disabled={!isCommentValid}
              accessibilityRole="button"
              accessibilityLabel={isReply ? 'Enviar resposta' : 'Enviar comentário'}
              style={{ opacity: isCommentValid ? 1 : 0.5 }}
              onPress={() =>
                isReply
                  ? submitReply(dataReply.id, comment, effectivePostId)
                  : handleCommentSubmit(comment, setComment, effectivePostId)
              }
            >
              <FontAwesome
                name="send-o"
                size={18}
                color="white"
                style={{
                  backgroundColor:
                    customColor && customColor.primary
                      ? customColor.primary
                      : THEME.COLORS.PRIMARY_900,
                  padding: '0.4rem',
                  borderRadius: '5px',
                }}
              />
            </Pressable>

            {isReply && (
              <Pressable onPress={() => setIsReply(false)}>
                <FontAwesome
                  name="close"
                  size={18}
                  color="white"
                  style={{
                    backgroundColor:
                      customColor && customColor.primary
                        ? customColor.primary
                        : THEME.COLORS.PRIMARY_900,
                    padding: '0.4rem',
                    borderRadius: '5px',
                  }}
                />
              </Pressable>
            )}
          </S.CommentContainer>
        }
      </SafeAreaView>
    </Provider>
  );
};

export default PostCommunity;
